module.exports = __webpack_public_path__ + "img/cross-shop.a903ed1c.svg";